import { maChatOpened } from '@wix/bi-logger-members-app-uou/v2';
import { RoleId } from '@wix/members-domain-ts';

import { getCommonBIEventsData } from '../../services/bi-event';
import { requestLogin } from '../../services/login-service';
import { Applications } from '../../services/public-api-store';
import type { Thunk } from '../../types';
import { Origin } from '../../types';
import { isMemberInCommunity } from '../selectors';
import { joinCommunity } from './role-action/community';

export const openChat: Thunk = () => async (dispatch, getState, extra) => {
  const state = getState();
  const { current, viewed } = state.users;
  const { wixCodeApi, getPublicAPI, biLogger, flowAPI, metaData } = extra;

  if (!current) {
    requestLogin(wixCodeApi);
    return;
  }

  if (!isMemberInCommunity(current)) {
    await joinCommunity(RoleId.JOIN_COMMUNITY)(dispatch, getState, extra);
    return;
  }

  const chatApi = await getPublicAPI(Applications.Chat);
  if (chatApi) {
    biLogger?.report(
      maChatOpened({
        ...getCommonBIEventsData(flowAPI, state, metaData),
        origin: Origin.Profile,
        messaged_member_id: viewed.uid,
      }),
    );
    chatApi.startPrivateChat(viewed.uid).catch(() => {});
  }
};
